import { render, staticRenderFns } from "./ExpensesView.vue?vue&type=template&id=8e3e3388&scoped=true"
import script from "./ExpensesView.vue?vue&type=script&lang=js"
export * from "./ExpensesView.vue?vue&type=script&lang=js"
import style0 from "./ExpensesView.vue?vue&type=style&index=0&id=8e3e3388&prod&lang=scss&scoped=true"
import style1 from "./ExpensesView.vue?vue&type=style&index=1&id=8e3e3388&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e3e3388",
  null
  
)

export default component.exports